import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import BrandLogo, { BrandBanner } from "../components/BrandLogo";
import { BRAND } from "../lib/brand";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 dotted-bg">
      <div className="w-full max-w-md nb-card-static p-8 animate-pop">
        <div className="flex flex-col items-stretch gap-3 mb-6">
          <BrandBanner />
          <div>
            <div className="text-[11px] uppercase tracking-wider font-bold text-[var(--muted-text)]">{BRAND.name}</div>
            <div className="inline-block tag tag-mint mt-3 mb-2">Join the class</div>
            <h1 className="font-display text-3xl sm:text-4xl font-bold">Create your account</h1>
            <p className="text-[var(--muted-text)] mt-2 text-sm">Sign up as a student to enroll in courses.</p>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider mb-1 block">Full name</label>
            <input data-testid="register-name-input" type="text" required value={name} onChange={(e) => setName(e.target.value)} className="nb-input" placeholder="Alex Johnson" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider mb-1 block">Email</label>
            <input data-testid="register-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="nb-input" placeholder="you@school.edu" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider mb-1 block">Password</label>
            <input data-testid="register-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="nb-input" placeholder="At least 6 characters" />
          </div>
          {error && <div data-testid="register-error" className="text-sm text-red-600 border-2 border-red-600 bg-red-50 px-3 py-2 rounded-lg">{error}</div>}
          <button data-testid="register-submit-btn" disabled={loading} type="submit" className="nb-btn nb-btn-mint w-full text-base">
            {loading ? "Creating..." : "Create account"}
          </button>
        </form>
        <div className="mt-6 text-sm text-center text-[var(--muted-text)]">
          Already have an account? <Link data-testid="register-to-login-link" to="/login" className="underline font-semibold text-black">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
